"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiPartner = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
const BizDevBaseEntity_1 = require("./BizDevBaseEntity");
let ApiPartner = class ApiPartner extends BizDevBaseEntity_1.BizDevBaseEntity {
    name;
    email;
    apiKey;
    phoneNumber;
    countryId;
    emailsEnabled = false;
    override = false;
    discountPercentage;
    ownerId;
    contracts;
    // sc-52334
    // when true, multiple vehicles are return of the same type
    // e.g. only sedan, or only van, never a combo sedan + van
    sameTypesForMultiVehicle = false;
};
exports.ApiPartner = ApiPartner;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Transform)(({ value }) => value && value.trim()),
    __metadata("design:type", String)
], ApiPartner.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], ApiPartner.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], ApiPartner.prototype, "apiKey", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ApiPartner.prototype, "phoneNumber", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], ApiPartner.prototype, "countryId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Boolean)
], ApiPartner.prototype, "emailsEnabled", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Boolean)
], ApiPartner.prototype, "override", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    __metadata("design:type", Number)
], ApiPartner.prototype, "discountPercentage", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ApiPartner.prototype, "ownerId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Array)
], ApiPartner.prototype, "contracts", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Boolean)
], ApiPartner.prototype, "sameTypesForMultiVehicle", void 0);
exports.ApiPartner = ApiPartner = __decorate([
    (0, typeorm_1.Entity)("apiPartners")
], ApiPartner);
//# sourceMappingURL=ApiPartner.js.map